const ENTERPRISE_SCRIPT_URL = 'https://www.google.com/recaptcha/enterprise.js';

export const RECAPTCHA_V2_REQUIRED = 'recaptcha_v2_required';

export function loadRecaptchaScript(siteKey) {
  return new Promise(resolve => {
    if (!siteKey) return resolve(false);

    const ready = () => {
      if (window.grecaptcha && window.grecaptcha.enterprise) {
        window.grecaptcha.enterprise.ready(() => resolve(true));
      } else {
        resolve(false);
      }
    };

    if (document.querySelector('script[src*="recaptcha/enterprise.js"]')) {
      return ready();
    }

    const script = document.createElement('script');
    script.src = `${ENTERPRISE_SCRIPT_URL}?render=${siteKey}`;
    script.async = true;
    script.onload = ready;
    script.onerror = () => resolve(false);
    document.head.appendChild(script);
  });
}

export function executeRecaptcha(siteKey, action) {
  if (!window.grecaptcha || !window.grecaptcha.enterprise || !siteKey) {
    return Promise.resolve('');
  }
  return window.grecaptcha.enterprise.execute(siteKey, { action });
}

// reCAPTCHA v2 (checkbox) — loaded on demand as a fallback when the v3 score is too low.
// Both v3 and v2 use the Enterprise script; v2 is rendered explicitly via grecaptcha.enterprise.render.

export function loadRecaptchaV2Script() {
  return new Promise(resolve => {
    const ready = () => {
      if (window.grecaptcha && window.grecaptcha.enterprise && typeof window.grecaptcha.enterprise.render === 'function') {
        resolve(true);
      } else {
        resolve(false);
      }
    };

    if (window.grecaptcha && window.grecaptcha.enterprise && typeof window.grecaptcha.enterprise.render === 'function') {
      return resolve(true);
    }

    if (document.querySelector('script[src*="recaptcha/enterprise.js"]')) {
      // Script is in the DOM but enterprise.render may not be ready yet — poll briefly.
      const start = Date.now();
      const tick = () => {
        if (window.grecaptcha && window.grecaptcha.enterprise && typeof window.grecaptcha.enterprise.render === 'function') {
          return resolve(true);
        }
        if (Date.now() - start > 5000) return resolve(false);
        setTimeout(tick, 50);
      };
      return tick();
    }

    const script = document.createElement('script');
    script.src = `${ENTERPRISE_SCRIPT_URL}?render=explicit`;
    script.async = true;
    script.defer = true;
    script.onload = ready;
    script.onerror = () => resolve(false);
    document.head.appendChild(script);
  });
}

export async function renderRecaptchaV2(container, siteKey) {
  if (!container || !siteKey) return null;
  const ok = await loadRecaptchaV2Script();
  if (!ok) return null;
  return new Promise((resolve, reject) => {
    try {
      const widgetId = window.grecaptcha.enterprise.render(container, {
        sitekey: siteKey,
        callback: token => resolve({ widgetId, token }),
        'expired-callback': () => reject(new Error('expired')),
        'error-callback': () => reject(new Error('error'))
      });
    } catch (err) {
      reject(err);
    }
  });
}

export function resetRecaptchaV2(widgetId) {
  if (window.grecaptcha && window.grecaptcha.enterprise && typeof window.grecaptcha.enterprise.reset === 'function') {
    window.grecaptcha.enterprise.reset(widgetId);
  }
}
